export function preparePromise(): [Promise<any>, (value: unknown) => void, (reason?: any) => any] {
    let resolve: (value: unknown) => void, reject: (reason?: any) => void;
    const promise = new Promise((_resolve, _reject) => {
        resolve = _resolve;
        reject = _reject;
    });

    return [promise, resolve!, reject!];
}
